/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function e(e){return e.isGeographic||e.isWebMercator}function r(e,r){switch(e.type){case"georeferenced":return r.isGeographic;case"local":return r.isGeographic||r.isWebMercator}}export{e as isGlobal,r as performGlobalOperation};
